// Page ouverte par le lien de confirmation de l'adresse e-mail (inscription dans l'app).
// Supabase a déjà confirmé l'adresse avant d'ouvrir cette page ; on referme la session ouverte sur
// le site et on renvoie vers l'app.

import { t } from '@shared/i18n';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabase';

export default function EmailConfirmed() {
  // lien expiré ou déjà utilisé : Supabase renvoie l'erreur dans l'adresse
  const [failed] = useState(() => /error=|error_code=/.test(window.location.hash + window.location.search));

  useEffect(() => {
    if (!supabase || failed) return;
    // la session créée par le lien ne sert à rien sur le site : on se connecte dans l'app
    const timer = setTimeout(() => supabase!.auth.signOut().catch(() => {}), 1500);
    return () => clearTimeout(timer);
  }, [failed]);

  return (
    <div className="container" style={{ maxWidth: 460, paddingTop: 56 }}>
      <div className="card stack" style={{ textAlign: 'center' }}>
        <span
          className="logo big"
          style={{ width: 64, height: 64, fontSize: '1.6rem', borderRadius: 18, margin: '0 auto' }}
        >
          FM
        </span>
        {failed ? (
          <>
            <h2 style={{ marginTop: 8 }}>{t('Lien plus valable', 'Link no longer valid')}</h2>
            <p className="muted">
              {t(
                'Ce lien a expiré ou a déjà été utilisé. Si ton adresse n’est pas encore confirmée, connecte-toi dans l’app FollowMe : elle te proposera de renvoyer l’e-mail.',
                'This link has expired or was already used. If your address is not confirmed yet, sign in to the FollowMe app: it will offer to resend the email.',
              )}
            </p>
          </>
        ) : (
          <>
            <h2 style={{ marginTop: 8 }}>{t('✓ Adresse e-mail confirmée', '✓ Email address confirmed')}</h2>
            <p className="muted">
              {t(
                'Merci ! Retourne dans l’app FollowMe et connecte-toi. Un organisateur va valider ton compte : tu recevras une notification.',
                'Thank you! Go back to the FollowMe app and sign in. An organiser will approve your account: you will get a notification.',
              )}
            </p>
          </>
        )}
        <Link to="/">{t('← Accueil', '← Home')}</Link>
      </div>
    </div>
  );
}
